export default "__VITE_ASSET__DflbmGaR__"